export enum VegetativeType {
  TREE = "tree",
  PROSTRAT_SHRUB = "prostrat_shrub",
  SHRUB = "shrub",
  SUB_SHRUB = "sub_shrub",
  HERBACEOUS = "herbaceous",
}
